export default IconInnerShadowTopRight => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-inner-shadow-top-right" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z" />
  <path d="M18 12a6 6 0 0 0 -6 -6" />
</svg>`;